import { INTERNAL_DATA, SOCIAL_LINKS } from '@/config/global-config'
import { SCHEMA_IDS, SITE_DESCRIPTION, SITE_URL, toAbsoluteUrl } from './constants'

const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const buildLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'ClothingStore',
  '@id': SCHEMA_IDS.localBusiness,
  parentOrganization: { '@id': SCHEMA_IDS.organization },
  name: 'Hydra Shop - Main Office',
  url: SITE_URL,
  description: SITE_DESCRIPTION,
  telephone: INTERNAL_DATA.hotline,
  email: INTERNAL_DATA.email,
  priceRange: INTERNAL_DATA.priceRange,
  image: toAbsoluteUrl(INTERNAL_DATA.logo),
  hasMap: INTERNAL_DATA.address_link,
  sameAs: [
    SOCIAL_LINKS.facebook,
    SOCIAL_LINKS.tiktok,
    SOCIAL_LINKS.instagram,
    SOCIAL_LINKS.youtube,
  ].filter(Boolean),
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: DAYS_OF_WEEK,
      opens: INTERNAL_DATA.openingHours.opens,
      closes: INTERNAL_DATA.openingHours.closes,
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: INTERNAL_DATA.streetAddress,
    addressLocality: INTERNAL_DATA.addressLocality,
    addressRegion: INTERNAL_DATA.addressRegion,
    postalCode: INTERNAL_DATA.postalCode,
    addressCountry: INTERNAL_DATA.addressCountry,
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: INTERNAL_DATA.geo.latitude,
    longitude: INTERNAL_DATA.geo.longitude,
  },
  areaServed: {
    '@type': 'Country',
    name: 'Vietnam',
  },
})
